import CreateEventCheckoutRequestModelBase from '../_generated/modelBases/create-event-checkout-request-model-base';

export default class CreateEventCheckoutRequestModel extends CreateEventCheckoutRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
